<template>
  <div>
    <!-- マイページコンテンツ -->
    <router-view></router-view>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'

  import LoggedInPageBase from 'extends/LoggedInPageBase.vue'

  export default {
    name:"MyPage",
    extends:LoggedInPageBase,
    components: {
    },
    data () {
      return {
      }
    },
    watch: {
      '$route' (to, from) {
      }
    },
    mounted(){
    },
    methods:{

    }
  }
</script>


<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// MyPage.vue?5764fb3b